import axios from 'axios';

import { env } from 'env';

const { REACT_APP_API_URL } = env;

export default class HRService {
  static getParticipantGoldenTicket() {
    return axios.get(`${REACT_APP_API_URL}api/v2/ixr/golden-ticket`, {
      responseType: 'arraybuffer',
    });
  }
}
